var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-t-40 bg-round bg-fff"},[_c('div',{staticClass:"container"},[_c('Bread')],1),_c('div',{staticClass:"container vhtml"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.detail.Content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }